import ServiceClient from './service-client';
import { service_url } from './service-constants';

class RelatorioService {

  static async getLojasSemPedidosAsync(model) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioLojasUltimosPedidos, model);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioAnaliticoAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioAnalitico, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getExcelRelatorioAnaliticoEmBytesAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.excelRelatorioAnalitico, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioAnaliticoUltimoPedidoPdf(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioUltimoPedidoPdf, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioComissaoEmPdfAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioComissaoPdf, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioMetasEmPdfAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioMetasPdf, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioMetasVolumeEmPdfAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioMetasVolumePdf, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioAnaliticoEmPdfAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioAnaliticoPdf, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioMetasAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioMetas, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioMetasVolumeAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioMetasVolume, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioMetasEmBytesAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioMetasBytes, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getRelatorioMetasVolumeEmBytesAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.relatorioMetasVolumeBytes, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoComissaoExcelAsync(filter) {
    try {
      var result = await ServiceClient.Get(service_url.excelRelatorioExtratoComissao, filter);

      return result;
    } catch (error) {
      console.log(error);
      return undefined;
    }
  }

  static async getFaturamentoCategorias(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetFaturamentoCategorias, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getTopLojas(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetFaturamentoTopLojas, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getRankingVendedores(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetRankingVendedores, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getRankingVendedoresVolume(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetRankingVendedoresVolume, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getFaturamentoVolume(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetFaturamentoVolume, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getFaturamentoPrecoMedio(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetFaturamentoPrecoMedio, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getFaturamentoPorcentagemCategoria(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetFaturamentoPorcentagemCategoria, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getFaturamentoRuptura(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetFaturamentoRuptura, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getFaturamentoMixClientesGeral(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetFaturamentoMixClientesGeral, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  //#region Extratos

  static async getExtratoTopLojas(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoTopLojas, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoRankingVendedores(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoRankingVendedores, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoRankingVendedoresVolume(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoRankingVendedoresVolume, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoPrecoMedio(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoPrecoMedio, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoFaturamentoCategorias(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoCategorias, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoFaturamentoVolume(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoFaturamentoVolume, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoPorcentagemCategoria(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoPorcentagemCategoria, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoRuptura(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoRuptura, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }

  static async getExtratoFaturamentoMixClientesGeral(filter){
    try{
      const result = await ServiceClient.Post(service_url.relatorioGetExtratoFaturamentoMixClientesGeral, filter || {});
      return result;
    }
    catch(error){
      console.log(error);
      return undefined;
    }
  }
  
  //#endregion
  
}

export default RelatorioService;
